$(function () {

    $("#single-like").click(function () {

        var post_id = $(this).attr('data-id');
        var this_post = $(this);
        var cookie_post_like = [];

        if (Cookies.get('post_like')) {
            cookie_post_like = Cookies.get('post_like').split('/');
        }

        if (!cookie_post_like[post_id]) {

            // Appel d'un fichier php pour modifier l'acf field en ajoutant +1 et créer un cookie
            $.ajax({
                url: $wpUrl + "/function/ajax/single-like.php",
                type: "post",
                data: "id=" + post_id,
                cache: false,
                processData: false,
                dataType: 'html',
                success: function () {

                    var count_like = this_post.attr('data-count');
                    $(".like > span").html(parseInt(count_like) + 1);
                    this_post.find('.like__button__content').addClass('active');

                    if (Cookies.get('post_like')) {
                        var cookie_post_like = Cookies.get('post_like');
                        var result = cookie_post_like + '/' + post_id;

                        Cookies.remove('post_like');
                        Cookies.set('post_like', result);
                    } else {
                        Cookies.set('post_like', post_id);
                    }

                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr);
                    console.log(ajaxOptions);
                    console.log(thrownError);
                }
            });

        }
    });

});
